// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = require('./_object-keys-internal');
var enumBugKeys = require('./_enum-bug-keys');

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};



//////////////////
// WEBPACK FOOTER
// ./~/.2.5.1@core-js/library/modules/_object-keys.js
// module id = 60
// module chunks = 0


// WEBPACK FOOTER //
// webpack:///~/.2.5.1@core-js/library/modules/_object-keys.js